import React from 'react';
import { Container, Box} from '@mui/material';

const Impressum = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
    <Box sx={{textAlign: 'center', py: 4, border:'1px solid #ddd',borderRadius: '8px',padding: '10px 20px',backgroundColor:'#ffffff' }}>
        <div>
        <h1>Impressum</h1>
        <p><strong>Angaben gemäß § 5 TMG:</strong></p>
        <p>
            Steffen Straub<br />
            Hauptstraße 48/1<br />
            73344 Gruibingen<br />
        </p>
        <p><strong>Kontakt:</strong></p>
        <p>
            E-Mail: steffen@straub-versicherungen.de<br />
        </p>
        <p><strong>Umsatzsteuer-ID:</strong></p>
        <p>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: -
        </p>
        <p><strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong></p>
        <p>
            Steffen Straub<br />
            Hauptstraße 48/1<br />
            73344 Gruibingen<br />
        </p>
        </div>
    </Box>
    </Container>
  );
};

export default Impressum;
